// 用户登录
<template>
  <div>
    <div>
      <el-row type="flex" justify="start" id="login-header">
        <div id="logo-div">
          <img src="../../assets/admin/logo.jpg" @click="navToHome">
        </div>
        <div>
          <div id="logo-title">欢迎登录</div>
        </div>
      </el-row>
    </div>
    <div style="background-color: #FAFAFA">
      <el-row type="flex" justify="space-around" align="middle">
        <div><img src="../../assets/admin/login_bg.jpg"></div>
        <div class="login-form">
          <el-row class="bottom-margin">
            <div style="padding-bottom:20px;display: none;">
            	<el-radio v-model="userType" label="00">企业</el-radio>
            	<el-radio v-model="userType" label="01">个人</el-radio>
            </div>
          </el-row>
          <el-row>
			  <el-image :src="loginPtCode" v-show="userType=='01'"></el-image>
            <el-form label-position="left" :model="ruleForm" status-icon :rules="rules" ref="ruleForm"
                     label-width="100px" :hide-required-asterisk="true"
                     class="demo-ruleForm" v-show="userType=='00'">
              <el-form-item label="手机号：" prop="userName">
                <el-input type="text" v-model="ruleForm.userName" @keyup.enter.native="submitForm"></el-input>
              </el-form-item>
              <el-form-item label="密码：" prop="password">
                <el-input type="password" v-model="ruleForm.password" @keyup.enter.native="submitForm"  show-password></el-input>
              </el-form-item>
			  
			  <Verify
			    @success="capctchaCheckSuccess"
			    :mode="'pop'"
			    :captchaType="'blockPuzzle'"
			    :imgSize="{ width: '330px', height: '155px' }"
			    ref="verify"
			  ></Verify>
			  
              <!-- <el-form-item label="验证码：">
                <el-col :span="12">
                  <el-input placeholder="请输入内容" v-model="ruleForm.validateCode"
                            @keyup.enter.native="submitForm"></el-input>
                </el-col>
                <el-col :span="12">
                  <div>
                    <el-image :src="captchaImageUrl" @click="refreshCaptchaImage" style="height: 40px"
                              fit="scale-down"/>
                  </div>
                </el-col>
              </el-form-item> -->
              <el-button id="login-btn" class="bottom-margin full-width" type="primary" @click="submitForm">
                登&nbsp;&nbsp;&nbsp;&nbsp;录
              </el-button>
            </el-form>
          </el-row>
          <el-row type="flex" justify="space-between">
            <span id="justify-span" class="font-small">
              <span>还没账号？</span>
              <el-link type="primary"  @click.native="navToRegister">立即注册</el-link>
            </span>
            <span><el-link  @click.native="navToForget">修改密码</el-link></span>
          </el-row>
        </div>
      </el-row>
    </div>
    <div id="login-footer">
      <span>
        版权所有 泰盈科技集团股份有限公司 ©2022 网站备案号：<a target="_blank" href="https://beian.miit.gov.cn/">鲁ICP备16023615号-3</a>
      </span>
    </div>
  </div>
</template>

<script>

  import Verify from "@/components/Verifition/Verify";
  import { encrypt } from "@/util/jsencrypt";
	
  export default {
	components: { Verify },
    data() {
      return {
		flag:0,
        captchaImageUrl: '/api/captcha/captchaImage?type=char',
        ruleForm: {
          userName: '',
          password: '',
          validateCode: ''
        },
		userType:'00',
		loginPtCode: require("../../assets/admin/login_pt_code.png"),
        rules: {
          userName: [
            {required: true, message: '请输入手机号', trigger: 'blur'},
          ],
          password: [
            {required: true, message: '请输入密码', trigger: 'blur'},
          ]
        }
      }
    },
    mounted() {
		this.flag=this.$route['params']['flag'];
    },
    created() {
    },
    computed: {},
    methods: {
		
	  capctchaCheckSuccess(params) {
	    this.ruleForm.code = params.captchaVerification;

	           this.$store.dispatch("LoginByUsername", {
	             username: this.ruleForm.userName,
	             password: encrypt(this.ruleForm.password),
	             validateCode: this.ruleForm.code,
	             rememberMe: true
	           }).then(() => {
	             if(this.flag){
	    				  this.toUserCenter();
	    				  this.$router.push("/");
	    			  }else{
	    				  this.$router.push("/")
	    			  }
	           }).catch(err => {
	             this.$message.error(err.msg)
	           })
	  },
		
      // 刷新验证码图片
      // refreshCaptchaImage() {
      //   this.captchaImageUrl = '/api/captcha/captchaImage?type=char&s=' + Math.random()
      // },
      submitForm() {
        this.$refs['ruleForm'].validate((valid) => {
          if (valid) {
			  this.$refs.verify.show();
			  
     //        this.$store.dispatch("LoginByUsername", {
     //          username: this.ruleForm.userName,
     //          password: this.ruleForm.password,
     //          validateCode: this.ruleForm.validateCode,
     //          rememberMe: true
     //        }).then(() => {
     //          if(this.flag){
				 //  this.toUserCenter();
				 //  this.$router.push("/");
			  // }else{
				 //  this.$router.push("/")
			  // }
     //        }).catch(err => {
     //          this.$message.error(err.msg)
     //        })
          } else {
            console.log('error submit!!')
            return false;
          }
        })
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      navToHome() {
        this.$router.push("/")
      },
	navToRegister(){
		this.$router.push("/register")
	},
	navToForget(){
		this.$router.push("/forget")
	},
	// 跳转到企业中心
	toUserCenter() {
	  window.open("https://admin.kefubang.com", '_blank')
	}
    }
  }
</script>

<style scoped>
  @import "../../assets/css/common.css";
  @import "../../assets/css/login.css";
</style>